import {IconButton} from '../../../../ui/buttons/icon-button';
import {openUploadWindow} from '../../../../uploads/utils/open-upload-window';
import {UploadInputType} from '../../../../uploads/types/upload-input-config';
import {AddAPhotoIcon} from '../../../../icons/material/AddAPhoto';
import {Button} from '../../../../ui/buttons/button';
import {UploadedFile} from '../../../../uploads/uploaded-file';
import {Trans} from '../../../../i18n/trans';
import {AvatarPlaceholderIcon} from './avatar-placeholder-icon';

export const MaxAvatarSize = 1572864;

interface AvatarManagerProps {
  className?: string;
  onUpload: (file: UploadedFile) => void;
  onRemove: () => void;
  value?: string;
  isLoading: boolean;
}
export function AvatarManager({
  value,
  isLoading,
  onUpload,
  onRemove,
  className,
}: AvatarManagerProps) {
  return (
    <div className={className}>
      <div className="text-sm mb-18">
        <Trans message="Profile image" />
      </div>
      <div className="w-90 h-90 relative">
        {value ? (
          <img
            src={value}
            className="w-full h-full rounded-full object-cover"
            alt=""
          />
        ) : (
          <AvatarPlaceholderIcon
            viewBox="0 0 48 48"
            className="w-full h-full text-primary/40 bg-primary-light/40 rounded-full"
          />
        )}
        <div className="bg-paper shadow-xl absolute -bottom-2 -right-2 rounded-full">
          <IconButton
            disabled={isLoading}
            type="button"
            size="sm"
            color="primary"
            onClick={async () => {
              const files = await openUploadWindow({
                types: [UploadInputType.image],
              });
              onUpload(files[0]);
            }}
          >
            <AddAPhotoIcon />
          </IconButton>
        </div>
      </div>
      <Button
        type="button"
        disabled={isLoading || !value}
        variant="link"
        color="primary"
        size="xs"
        className="mt-18"
        onClick={() => {
          onRemove();
        }}
      >
        <Trans message="Remove image" />
      </Button>
    </div>
  );
}
